import { AxiosResponse } from 'axios';
import { api } from '../../../api';
import { ApiResponse, PageResult } from '../../Utilities';
import { CreateUpdateDeleteViewModel, PermissionViewModel, RoleTypeViewModel } from '../../ViewModels';
import { GetRoleTypeParams } from './Params';
import { RecursivePartial } from '../../../../types';

export class RoleTypeApi {
    private route = '/RoleType';

    public getRoleTypes = (params: GetRoleTypeParams): Promise<AxiosResponse<PageResult<RoleTypeViewModel>>> => {
        return api().get(this.route, { params });
    };

    public getRoleType = (id: number, params: GetRoleTypeParams): ApiResponse<RoleTypeViewModel> => {
        return api().get(`${this.route}/${id}`, { params });
    };

    public postRoleType = (roleType: RecursivePartial<RoleTypeViewModel>): ApiResponse<CreateUpdateDeleteViewModel> => {
        return api().post(this.route, roleType);
    };

    public putRoleType = (
        id: number,
        roleType: RecursivePartial<RoleTypeViewModel>
    ): ApiResponse<CreateUpdateDeleteViewModel> => {
        return api().put(`${this.route}/${id}`, roleType);
    };

    public deleteRoleType = (id: number): ApiResponse<CreateUpdateDeleteViewModel> => {
        return api().delete(`${this.route}/${id}`);
    };

    public getPermissions = (): ApiResponse<PermissionViewModel[]> => {
        return api().get(`${this.route}/Permission`);
    };
}
